<div class="card">
    <div class="card-body">
        <fieldset class="col-12">
            <legend>Encuesta del curso</legend>
            <div class="card">
                <div class="card-body">
                    <div class="form-row">
                        <div class="form-group col-md-10">
                            <label>Curso</label>
                            <select class="form-control" >
                              <option value="">Seleccionar</option>
                              <ng-container *ngFor="let item of dataCourses">
                                <option  [ngValue]="item.cou_in_id">{{item.cou_vc_name}}
                                </option>
                              </ng-container>
                            </select>
                          </div>
                          <div class="form-group col-md-2">
                            <label class="col-md-12">&nbsp;</label>
                            <button class="btn btn-badminton btn-sm pull-right" (click)="addquestion()">Agregar Pregunta</button>
                          </div>
                    </div>
                </div>
            </div>
        </fieldset>


        <fieldset class="col-12">
          <legend>Listado</legend>
      
          <div class="card">
            <div class="card-body">
              
              <div class="mat-elevation-z8 table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
                
              
                  <!-- Name Column -->
                  <ng-container matColumnDef="coquti_tx_description">
                    <th style="width: 65%;" mat-header-cell *matHeaderCellDef mat-sort-header> Titulo </th>
                    <td mat-cell *matCellDef="let row">{{row.coquti_tx_description}} </td>
                  </ng-container>
    
                 
                  
                  <ng-container matColumnDef="opcion">
                    <th  style="width: 35%;" mat-header-cell *matHeaderCellDef> Opciones</th>
                    <td  mat-cell *matCellDef="let element">
                      
                      <a (click)="create_quiz(element)"  class="pr-2"><i class="fa fa-edit"></i> Crear Encuesta</a>
                      <a (click)="asign_quiz(element)"  class="pr-2"><i class="fa fa-eye"></i> Asignar</a>
                      <!--  <a   class="pr-2"><i class="fa fa-eye"></i> Empleados</a> -->
                    <!--  <a   class="pr-2"><i class="fa fa-edit"></i> Editar</a>-->
                      <a (click)="delete_quiz_title(element)"  class="pr-2"><i class="fa fa-remover"></i> Eliminar</a>
                    </td>
                  </ng-container>
      
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              
                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter</td>
                  </tr>
                </table>
              
                <mat-paginator #paginatorDatasource [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
              </div>
      
            </div>
          </div>
      
          </fieldset>
    </div>
</div>
